export const ProductLaunchesTitleText = "Product Launches";

export const UntitledLaunchText = "Untitled launch";
export const LoadMoreText = "LOAD MORE";

export const NoLaunchesText = "No product launches... yet!";
export const NoLaunchesSubText = "New launches will appear here as soon as they are announced.";

export const LaunchesErrorText = "We couldn't load the product launches";
export const LaunchesErrorSubText = "Please try again in a few minutes.";
